import * as mat from './lib/jsmatrix';

function computeTransformedDistanceSquared(M, a, b) {
    b = mat.optional(b, mat.zeros(a.rows(), a.cols(), a.type()));

    const am = mat.mult(M, mat.hvec(a));
    const bm = mat.mult(M, mat.hvec(b));

    return mat.norm2Squared(
        mat.sub(mat.subvec(mat.homogenize(am), 0, 3),
            mat.subvec(mat.homogenize(bm), 0, 3)));

}


export {
    computeTransformedDistanceSquared
};